import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5a90ce82")

_pushScopeId("data-v-5a90ce82")
const _hoisted_1 = {
  id: "kkbo-info",
  class: "kkboRoot"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("p", null, " As of right now, KKBO is under construction. I have lots of ideas and features planned for this application, but it has been hard to find the time to flesh them out while working full time. ", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("p", null, " There isn't much now, but feel free to check out the landing site (also under construction) to read more detailed information about KKBO. ", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" CHECK OUT KKBO ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode(_component_Button, {
      color: "secondary",
      component: "a",
      href: "https://kkbo.io",
      target: "_blank",
      rel: "noopener noreferrer"
    }, {
      default: _withId(() => [
        _hoisted_4
      ]),
      _: 1
    })
  ]))
})